import React, { useCallback } from 'react'
import s from './GeoentityMorePois.less'
import { useSelector } from 'react-redux'
import { useAction } from '../utils/react-redux'
import { navigateToSearchByApp } from '../../store/history/history.actions'
import { selectSelectedGeoentity } from '../../store/geoentity/geoentity.selectors'
import {
  getMatchingConfig,
  CONFIG_TYPES,
  selectSubCategoryContainingApp
} from '../../store/poiassets/poiassets.selectors'
import { TAG_CLICK_CATEGORY_MORE } from '../../store/analytics/analytics.actionTypes'
import RectangleActionButton, { COLOR_GREY_EMPTY } from '../genericComponents/buttons/RectangleActionButton'

export const GeoentityMorePois = () => {
  const geoentity = useSelector(selectSelectedGeoentity)
  const appId = geoentity?.additionalInfo?.appId
  const appData = useSelector(store => getMatchingConfig(store)(CONFIG_TYPES.application, appId))
  const subcategory = useSelector(store => selectSubCategoryContainingApp(store, { id: appId }))
  const execNavigateToSearchByApp = useAction(navigateToSearchByApp)

  const onClick = useCallback(() => execNavigateToSearchByApp(appId), [appId, execNavigateToSearchByApp])

  if (!appId || !appData || !appData.morePoisLabel) return null

  return (
    <div className={s.content}>
      <RectangleActionButton
        color={COLOR_GREY_EMPTY}
        label={appData.morePoisLabel}
        tagData={{
          type: TAG_CLICK_CATEGORY_MORE,
          tagInfo: {
            catId: subcategory?.id,
            appId
          }
        }}
        imgSrc={appData.mob_roundImage}
        imgAlt={appData.name}
        onClick={onClick}
        deferClick
      />
    </div>
  )
}

export default GeoentityMorePois
